<div class="empty-panel"></div>

<div class="side-panel">

    <app-report-select></app-report-select>
    <form  [formGroup]="searchForm" novalidate class="voffset-20" (ngSubmit)="onSubmit()">
        <div class="form-group form-horizontal">

            <div class="row voffset20">
                <div class="col-6">
                    <div class="form-group form-horizontal ">
                        <label class="panel-label">{{ 'CapacityReport.DateFrom' | translate }}</label>
                        <bcui-date-picker-input2 class="date-picker" formControlName="dateFrom" name="dateFrom" hznTestId="capacity-report-date-from">
                        </bcui-date-picker-input2>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group form-horizontal">
                        <label class="panel-label">{{ 'CapacityReport.DateTo' | translate }}</label>
                        <bcui-date-picker-input2 class="date-picker" formControlName="dateTo" name="dateTo" hznTestId="capacity-report-date-to"
                            inputMask="00/00/0000"
                            inputDateFormat="MM/DD/YYYY">
                        </bcui-date-picker-input2>
                    </div>
                </div>
            </div>

            <div class="row form-group form-horizontal">
                    <div class="col-12">
                        <label class="panel-label">{{ 'CapacityReport.SessionName' | translate }}</label>
                        <input maxlength="200" class="form-control" formControlName="sessionName" hznTestId="capacity-report-session-name">
                    </div>
                </div>

                <div class="form-group form-horizontal voffset20">
                    <label class="panel-label">{{ 'CapacityReport.Club' | translate }}</label>
                    <bcu-drop-down-multiselect-cf2 hznTestId="capacity-report-club" [isDisabled]="isBusy" [options]="clubDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true"
                        (changed)="onClubsChanged($event)">
                    </bcu-drop-down-multiselect-cf2>
                </div>

                <div class="form-group form-horizontal voffset20">
                    <label class="panel-label">{{ 'CapacityReport.Category' | translate }}</label>
                    <bcu-drop-down-multiselect-cf2 hznTestId="capacity-report-category" [isDisabled]="isBusy" [options]="categorieDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true"
                        (changed)="onCategoryChanged($event)">
                    </bcu-drop-down-multiselect-cf2>
                </div>

                <div class="form-group form-horizontal voffset20">
                    <label class="panel-label">{{ 'CapacityReport.CampType' | translate }}</label>
                    <bcu-drop-down-multiselect-cf2 hznTestId="capacity-report-camp-type" [options]="campTypeDropdownItems" [shortenWhenAllSelected]="true" [selectAllOption]="true" (changed)="onCampTypeChanged($event)">
                    </bcu-drop-down-multiselect-cf2>
                </div>

            <div class="row d-flex align-items-end">
                <div class="col">
                    <button class="btn btn-primary pull-right" type="submit" hznTestId="capacity-report-search" [disabled]="!isFormValid()">{{'CapacityReport.Search' | translate}}</button>
                </div>
            </div>

        </div>
    </form>
</div>
